// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1LHwa","buttons":"SendReceipts_buttons__1FAS1","email":"SendReceipts_email__2QzgI","bookApptTitle":"SendReceipts_bookApptTitle__3ewB-"};